import BaseCard from './BaseCard';
import { CardType } from './CardType';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';

export default class KeyCard extends BaseCard {
    public onCreate(params: any): void {
        params.cardFrontTexture = 'card_key';
        params.type = CardType.key;
        params.dragonbonesName = 'lock_key';
        params.armatureName = 'key';
        params.armatureObjectName = 'lock_armature';
        params.forceHideArmature = true;
        super.onCreate(params);
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources('lock_key', `${DRAGONBONES_PATH}/LockKey/`);
    }
}
